import { Component, Vue } from 'vue-property-decorator';
import WithRender from './changepassword.html';
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import { IUserInfo } from '@/Models/IUserInfo';
import Loading from 'vue-loading-overlay';
import { userAuth } from "@/services/security";


@WithRender
@Component({
  components: {
    Loading,
  }
})
export default class ChangePassword extends Vue {
  userInfo: IUserInfo = {} as IUserInfo;
  isLoading = false;
  form = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  }

  async onSubmit(event: any) {
    event.preventDefault()
    if (this.form.newPassword.trim() == '') {
      this.ErrorNotification('Please enter a new password', 'danger');
      return;
    }
    if (this.form.confirmPassword != this.form.newPassword) {
      this.ErrorNotification('New password and Password confirm, should be the same', 'danger');
      return;
    }
    try {
      this.isLoading = true;
      await _axios.post(config.gateway + "customerdata/user/changepassword", this.form);
      let user = userAuth.data().user.user;
      if (user && user.profile.ReferralFirstLogin)
       {
        user.profile.ReferralFirstLogin = null;
        await this.$store.dispatch('login/setUser', user);
       } 
      this.ErrorNotification('Password has been successfully changed', 'success');
    } catch (error) {
      const err = error as any;
      if (err.response && err.response.status && err.response.status == '400')
        this.ErrorNotification(err.response.data, 'danger');
      else
      this.ErrorNotification("please check that you have data or your internet connection is on.", 'danger');
    }
    finally {
      this.isLoading = false;
    }
  }

  private ErrorNotification(message: string, type: string) {
    this.$bvToast.toast(message, {
      title: 'Notification',
      variant: type,
      autoHideDelay: 5000,
    });
  }
}
